import React, { Component, Fragment } from "react";
import { Card, Icon, Tag, Radio, Checkbox, Row, Col } from "antd";
import WizardFooter from "./wizard-footer";
import SecondaryHome from "./images/new/homeowners.svg";
import MFGHome from "./images/new/mfg.svg";
import Condominium from "./images/new/condominium.svg";
// import Landlord from "./images/new/bfile-landlord.svg";
import Other from "./images/new/other.svg";
import VacantProperty from "./images/new/vacant-land.svg";
import { Translate } from "react-translated";
import WizardPager from "../../../components/wizard-pager";
import ZillowSecondaryHomeValueContainer from "./zillow-secondary-home-value-container_updated";

const RadioGroup = Radio.Group;

class Step extends Component {
  render() {
    const { wizard, updateField, handleBlur, updateRadioBtnToggle } = this.props;

    let secondary_home_type = [];
    if (wizard.secondary_home_type !== "") {
      secondary_home_type = JSON.parse(wizard.secondary_home_type);
    }

    const secondary_home_types = [
      {
        name: "Secondary Home",
        icon: SecondaryHome
      },
      {
        name: "Condominium",
        icon: Condominium
      },
      {
        name: "Rentals",
        icon: MFGHome
      },
      // {
      //   name: "Landlord",
      //   icon: Landlord
      // },
      {
        name: "Vacant Property",
        icon: VacantProperty
      },
      {
        name: "Others",
        icon: Other
      }
    ];

    return (
      <Fragment>
        <div className="stepBody">
          <Card
            className="insidecard stepcard"
          >
            <h5 className="headingText">“Do you own any secondary properties? (Second Home, Rentals, Condo, Vacant Land) ?” <span className='asteriskIcon'>*</span></h5>
            <RadioGroup className="radiogroup"
              value={wizard.secondary_home_toggle}
              onChange={(e) => {
                updateField("secondary_home_toggle", e.target.value);
                if (!this.props.isExternalBFile) {
                  updateRadioBtnToggle();
                }
              }
              }

            >
              <Radio value="1">
                <Translate text={`Yes`} />
              </Radio>
              <Radio value="0">
                <Translate text={`No`} />
              </Radio>
            </RadioGroup>


            {wizard.secondary_home_toggle === "1" ? (
              <div style={{ marginTop: 20 }}>
                <h5 className="titleText2 headingText">
                  “Please select all owned secondary properties :” <span className='asteriskIcon'>*</span>
                </h5>
                <Checkbox.Group
                  className=""
                  value={secondary_home_type}
                  style={{ width: "100%" }}
                  onChange={(checkedList) => {
                    updateField(
                      "secondary_home_type",
                      JSON.stringify(checkedList)
                    );
                    if (!this.props.isExternalBFile) {
                      updateRadioBtnToggle();
                    }
                  }
                  }

                >
                  <Row gutter={[16, 16]} style={{ display: 'flex', flexWrap: 'wrap' }}>
                    {secondary_home_types.map((item, i) => {
                      return (
                        <Col key={i}
                          xs={24}
                          sm={12}
                          md={8}
                          lg={6} className="checkbox_layout">
                          <Checkbox value={item.name} style={{ width: "100%" }}>
                            <div className="checkbox_items"
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "10px",
                              }}
                            >
                              <div className="icon"
                                style={{ flexShrink: 0 }}
                              >
                                <img src={item.icon} alt={item.name}
                                  style={{
                                    objectFit: "contain",
                                  }}
                                />
                              </div>
                              <div className="title" style={{ flexGrow: 1 }}>
                                <Translate text={item.name} />
                              </div>
                            </div>
                          </Checkbox>
                        </Col>
                      );
                    })}
                  </Row>
                </Checkbox.Group>

                {wizard.secondary_home_type && wizard.secondary_home_type.length > 2 && <ZillowSecondaryHomeValueContainer {...this.props} />}
              </div>
            ) : null}

            {/* <WizardPager
            updateField={updateField}
            stepIndexPages={[4, 5, 6, 7, 8]}
            wizardStepIndex={wizard.stepIndex}
          /> */}
            <Row style={{ display: 'flex', justifyContent: 'center', marginTop: '30px' }} className='center'>
              <Col span={18} className='didyouKnowSection'>
                {/* <img src={require("./images/didyouKnow.png")} width={120} className='imgdid' /> */}
                <img src={require('./images/didYouKnowBulb.jpg')} width={40} alt='' />
                <h4>Did You Know</h4>
                <p className="textContent textContent">  &quot;The equity in your home may be at risk in the event of a liability lawsuit.&quot;</p>
              </Col>
            </Row>
            {/* <WizardFooter {...this.props} /> */}
          </Card>
        </div>
        <div className='stepFooter'>
          <WizardFooter {...this.props} />
        </div>
      </Fragment>
    );
  }
}

export default Step;



// WEBPACK FOOTER //
// ./src/scenes/Wizard/parts/step3_2_updated.js